import React from "react";
import { Typography, makeStyles } from "@material-ui/core";
import { useIntl } from "react-intl";
import chatMessages from '../chat/messages';
import { BaseNotificationView, useNotificationStyles } from "./BaseNotificationView";
import { useMfwThemeProvider } from "myfitworld-utils";
import { MarketplaceActivity } from "myfitworld-model/src/firestoreCollectionTypes/Activity";
import getLocalizedProperty from "src/utils/getLocalizedProperty";

const useStyles = makeStyles((theme) => ({
  messageText: {
    fontSize: '14px',
    color: theme.palette.text.secondary,
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
  },
  statusText: {
    fontSize: '13px',
    color: theme.palette.primary.main,
    marginTop: theme.spacing(1),
  }
}));

interface MarketplaceNotificationViewProps {
  activity: MarketplaceActivity;
}

const MarketplaceNotificationView: React.FC<MarketplaceNotificationViewProps> = ({
  activity
}) => {
  const classes = useStyles();
  const { formatMessage, locale } = useIntl();

  return (
    <BaseNotificationView
      activity={activity}
      headerLabel={formatMessage(chatMessages.marketplace_notification_title)}
    >
      <Typography className={classes.messageText}>
        {formatMessage(chatMessages.marketplace_notification_text, {contentName: getLocalizedProperty(locale, activity.workoutName), name: activity.customerName, email: activity.customerEmail})}
      </Typography>
    </BaseNotificationView>
  );
};

export default MarketplaceNotificationView;